import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Box, Paper, Tab, Tabs } from '@mui/material';

import RegionalPoolRequestsGrid, {
  FILTER
} from 'components/regional-pool-portal/RegionalPoolRequestsGrid';
import StyledTabs from 'components/shared/StyledTabs';
import TabPanel from 'components/shared/TabPanel';

interface Props {
  isRegionalPool: boolean;
}

const RegionalPoolRequests = ({ isRegionalPool }: Props) => {
  const { t } = useTranslation('common');
  const [activeTab, setActiveTab] = useState(0);

  const onChangeActiveTab = (e, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <StyledTabs>
        <Paper
          square
          sx={{
            position: 'sticky',
            top: 0,
            backgroundColor: '#FFF',
            zIndex: 40
          }}
        >
          <Tabs
            indicatorColor="primary"
            textColor="primary"
            value={activeTab}
            onChange={onChangeActiveTab}
          >
            <Tab key={FILTER.OPEN} label={t('openDuties')} value={0}></Tab>
            <Tab
              key={FILTER.REGIONALPOOL}
              label={t('fulfilled')}
              value={1}
            ></Tab>
            <Tab
              key={FILTER.PENDING}
              label={t('waitingForApproval')}
              value={2}
            ></Tab>
            <Tab key={FILTER.ALL} label={t('allDuties')} value={3}></Tab>
          </Tabs>
        </Paper>
        <Box position="relative" p={2}>
          <TabPanel index={0} value={activeTab} title={t('openDuties')}>
            <RegionalPoolRequestsGrid
              isRegionalPool={isRegionalPool}
              filter={FILTER.OPEN}
              period="week"
            />
          </TabPanel>
          <TabPanel index={1} value={activeTab} title={t('fulfilled')}>
            <RegionalPoolRequestsGrid
              isRegionalPool={isRegionalPool}
              filter={FILTER.REGIONALPOOL}
              period="week"
            />
          </TabPanel>
          <TabPanel index={2} value={activeTab} title={t('waitingForApproval')}>
            <RegionalPoolRequestsGrid
              isRegionalPool={isRegionalPool}
              filter={FILTER.PENDING}
              period="month"
            />
          </TabPanel>
          <TabPanel index={3} value={activeTab} title={t('allDuties')}>
            <RegionalPoolRequestsGrid
              isRegionalPool={isRegionalPool}
              filter={FILTER.ALL}
              period="week"
            />
          </TabPanel>
        </Box>
      </StyledTabs>
    </>
  );
};

export default RegionalPoolRequests;
